import { useTranslation } from "react-i18next";
import { z } from "zod";

export const usePowerOfAttorneyDokobitConsentSchema = () => {
  const { t } = useTranslation();

  return z.object({
    firstName: z
      .string({ required_error: t("common.form.field.errors.required") })
      .min(1, t("common.form.field.errors.required")),
    lastName: z
      .string({ required_error: t("common.form.field.errors.required") })
      .min(1, t("common.form.field.errors.required")),
    personalCode: z
      .string({ required_error: t("common.form.field.errors.required") })
      .min(1, t("common.form.field.errors.required")),
  });
};
